import { render, staticRenderFns } from "./choose-filters.vue?vue&type=template&id=0489b208&scoped=true&"
import script from "./choose-filters.vue?vue&type=script&lang=js&"
export * from "./choose-filters.vue?vue&type=script&lang=js&"
import style0 from "./choose-filters.vue?vue&type=style&index=0&id=0489b208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489b208",
  null
  
)

export default component.exports